export default __webpack_public_path__ + "static/media/phone-2-black@2x.07c333cb.png";